import { httpClient } from '@/services/http/httpClient'

type DeletePortfolioInviteData = {
  portfolioInviteId: string
}

export async function deletePortfolioInvite({
  portfolioInviteId,
}: DeletePortfolioInviteData) {
  await httpClient.delete(`/projects/portfolio-invites/${portfolioInviteId}`)
}
